import React from 'react';
import { ArrowRight, Clock, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden pt-12 pb-16 md:pt-20 md:pb-24" data-id="element-116">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-117">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-118">
          {/* Content */}
          <div className="order-2 md:order-1 space-y-6" data-id="element-119">
            <div className="inline-flex items-center space-x-2 bg-[#C4705A]/10 text-[#C4705A] px-3 py-1 rounded-full text-sm font-medium" data-id="element-120">
              <Clock className="w-4 h-4" data-id="element-121" />
              <span data-id="element-122">Solo 7 minutos al día</span>
            </div>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#2D2A26] leading-[1.1]" data-id="element-123">
              Alivio de Cuello y Espalda en 14 Días
            </h1>

            <p className="text-xl md:text-2xl text-[#2D2A26]/80 font-medium" data-id="element-124">
              El método Reset 7×3 para mujeres ocupadas (25–65+)
            </p>

            <p className="text-lg text-[#2D2A26]/70 leading-relaxed max-w-lg" data-id="element-125">
              Menos rigidez, menos dolor "de pantalla" y más movilidad con
              micro-rutinas seguras, sin equipo y sin gimnasio.
            </p>

            <div className="pt-4 flex flex-col sm:flex-row gap-4" data-id="element-126">
              <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} className="bg-[#C4705A] hover:bg-[#A65D4A] text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors flex items-center justify-center gap-2 shadow-lg shadow-[#C4705A]/20" data-id="element-127">
                Obtener Alivio Ahora - $6.39
                <ArrowRight className="w-5 h-5" data-id="element-128" />
              </button>
            </div>

            <div className="flex items-center gap-2 text-sm text-[#2D2A26]/60" data-id="element-129">
              <ShieldCheck className="w-4 h-4" data-id="element-130" />
              <span data-id="element-131">Pago seguro y descarga inmediata</span>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 md:order-2 flex justify-center relative" data-id="element-132">
            <div className="absolute inset-0 bg-[#C4705A]/5 rounded-full blur-3xl transform scale-90 translate-y-4 -z-10" data-id="element-133"></div>
            <img src="https://cdn.magicpatterns.com/uploads/3DVnGsE9oW3KMduEVZPhCR/image_(25).jpg" alt="Portada del Ebook Alivio de Cuello y Espalda" className="w-full max-w-md rounded-xl shadow-2xl transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-134" />
          </div>
        </div>
      </div>
    </section>;
}